/**
 * Debug logging utility for Responza
 * Enable/disable via VITE_RESPONZA_DEBUG environment variable
 */
export function responzaDebug(...args) {
  if (import.meta.env.VITE_RESPONZA_DEBUG) {
    //console.log(...args);
  }
}

export function responzaDebugError(...args) {
  if (import.meta.env.VITE_RESPONZA_DEBUG) {
    //console.error(...args);
  }
}
